import React from "react";
import Layout from "Layout";
import Form from "./form";
import useApi from "Hooks/useApi";
import useError from "Hooks/useError";
import { message } from "constants/message";
import { withRouter } from "react-router";
import useAuth from "Hooks/useAuth";
import googleAnalytics from "fuction/googleAnalytics";

function Users(props) {
  const { request } = useApi();
  const { state } = useAuth();
  const stateError = useError();
  const messages = message();

  React.useEffect(() => {
    // タイトル変更
    document.title = "Buzz Finder - ユーザ登録";
  }, []);

  React.useEffect(() => {
    googleAnalytics(props.location.pathname, state.user.account_id);
  }, [props.location.pathname]);

  const handleSubmit = ({ name, email, password, userType }) => {
    request({
      method: "POST",
      url: `config/:account_id/users`,
      data: {
        name: name,
        email: email,
        password: password,
        user_type: userType,
      },
    })
      .then((data) => {
        stateError.initialize();
        props.history.push("/config/user?success=create");
      })
      .catch((error) => {
        stateError.dispatch({
          type: "set",
          payload: {
            isError: true,
            errorMsg: messages.validation.common,
          },
        });
      });
  };
  return (
    <Layout
      content={
        <Form
          submit={handleSubmit}
        />
      }
    />
  );
}
export default withRouter(Users);
